import { Injectable } from "@angular/core";
import { ServerType } from "src/service/app-init.service";
import { RestApiService } from "src/service/rest-api.service";
import { BehaviorSubject } from "rxjs";
import { NotificationSettingsRequest } from "src/app/model/user/notification-settings-request";

@Injectable({
  providedIn: "root",
})
export class NotificationService {
  constructor(
    private restApiService: RestApiService
  ) {

  }

  currentMessage = new BehaviorSubject<any>(null);

  getNotificationList(page: number, size: number) {
    return this.restApiService.get(ServerType.NOTIFICATION, "messages", {
      params: { page, size },
    });
  }


  updateNotificationSettings(
    notificationSettings: NotificationSettingsRequest
  ) {
    return this.restApiService.post(
      ServerType.NOTIFICATION,
       "messages/update-notification-settings",
      notificationSettings
    );
  }

  getNotificationSettings(){
    return this.restApiService.get(
      ServerType.NOTIFICATION,
      "messages/get-notification-settings"
    )
  }

  setAsRead(messageIds: number[]) {
    return this.restApiService.post(ServerType.NOTIFICATION, "messages/read", {
      messageIds,
    });
  }

  delete(id: number) {
    return this.restApiService.get(
      ServerType.NOTIFICATION,
      `messages/delete/${id}`
    );
  }

  getNotificationCount() {
    return this.restApiService.get(ServerType.NOTIFICATION, "messages/count");
  }
}
